// extracted by mini-css-extract-plugin
module.exports = {"Wrap":"DraggableContainer_Wrap__1x4wW","Box":"DraggableContainer_Box__iTOfB"};